import {API_URL, apiDelete} from '../api'

export const deleteCampaign = async (id?: string) => {
    return await apiDelete(API_URL, `admin/campaign/${id}`)
}
